import "core-js/modules/web.dom-collections.iterator";
import _slicedToArray from "d:\\GiladL\\_projects\\use-gestures-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "d:\\GiladL\\_projects\\use-gestures-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";

/* Created by Gilad Lev-Ari[giladl82@gmail.com] */
import { useState, useRef, useEffect } from "react";

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread2(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(b, !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(b).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var Pointer = function Pointer(a) {
  _classCallCheck(this, Pointer);

  this.x = a.clientX, this.y = a.clientY;
};

var debounce = function debounce(a, b) {
  var c;
  return function () {
    for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) {
      e[f] = arguments[f];
    }

    var g = this;
    clearTimeout(c), c = setTimeout(function () {
      return a.apply(g, e);
    }, b);
  };
},
    getDistance = function getDistance(a, b) {
  var c = Math.pow;
  var d = c(a.x - b.x, 2),
      e = c(a.y - b.y, 2);
  return Math.sqrt(d + e);
},
    getAngleDeg = function getAngleDeg(a, b) {
  return 180 * Math.atan2(a.y - b.y, a.x - b.x) / Math.PI;
};

function useGestures(a, b) {
  var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {
    minDelta: 30
  };

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      d = _useState2[0],
      e = _useState2[1],
      _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      f = _useState4[0],
      g = _useState4[1],
      h = useRef(null);

  useEffect(function () {
    var i = a.current,
        j = function j(a, b, c) {
      var d = h.current;

      if (2 === b.length) {
        var _e = new Pointer(b[0]),
            _f = new Pointer(b[1]),
            _g = getDistance(_e, _f);

        return {
          preventDefault: a.preventDefault,
          stopPropagation: a.stopPropagation,
          pointers: [_e, _f],
          delta: c ? _g - c.distance : 0,
          scale: d ? _g / d.distance : 1,
          distance: _g,
          angleDeg: getAngleDeg(_e, _f)
        };
      } else {
        var _e2 = new Pointer(b[0]);

        return _objectSpread2({
          preventDefault: a.preventDefault,
          stopPropagation: a.stopPropagation
        }, _e2, {
          deltaX: c ? _e2.x - c.x : 0,
          deltaY: c ? _e2.y - c.y : 0,
          delta: c ? getDistance(_e2, c) : 0,
          distance: d ? getDistance(_e2, d) : 0,
          angleDeg: c ? getAngleDeg(_e2, c) : 0
        });
      }
    },
        k = function k(a, c) {
      a && b[a] && "function" == typeof b[a] && b[a](c);
    },
        l = function l(a) {
      var b = j(a, a.touches, null);
      e(b), h.current = b, 2 === a.touches.length ? k("onPinchStart", b) : k("onPanStart", b);
    },
        m = function m(a) {
      var b = Math.abs;
      var f = j(a, a.touches, d);
      if (e(f), 2 === a.touches.length) k("onPinchChanged", f);else {
        k("onPanMove", f);

        var _a, _e3;

        b(f.deltaX) >= c.minDelta && b(f.deltaY) < c.minDelta ? 0 > f.deltaX ? (_a = "onSwipeLeft", _e3 = "swipeLeft") : (_a = "onSwipeRight", _e3 = "swipeRight") : b(f.deltaX) < c.minDelta && b(f.deltaY) >= c.minDelta ? 0 > f.deltaY ? (_a = "onSwipeUp", _e3 = "swipeUp") : (_a = "onSwipeDown", _e3 = "swipeDown") : _e3 = "", _a && debounce(function (a, b, c) {
          k(a, b), g(c);
        }, 100)(_a, d, _e3);
      }
    },
        n = function n(a) {
      var b = j(a, a.changedTouches, null);
      d && d.pointers && (2 === d.pointers.length ? k("onPinchEnd", b) : k("onPanEnd", b)), f && k("on".concat(f.charAt(0).toUpperCase() + f.slice(1), "End"), b);
    };

    return i.addEventListener("touchstart", l), i.addEventListener("touchmove", m), i.addEventListener("touchend", n), function () {
      i.removeEventListener("touchstart", l), i.removeEventListener("touchmove", m), i.removeEventListener("touchend", n);
    };
  });
}

export default useGestures;